export default __webpack_public_path__ + "static/media/bg-terms-of-use.d933bef1.png";